import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { IAPIListRequestOptions, IAPIListResponse } from '@sondermind/utilities/models-http';

import {
  clientTestimonialResponseTransformer, IClientTestimonial, IClientTestimonialResponse
} from '../models/client-testimonial.interface';

@Injectable({
  providedIn: 'root'
})
export class ClientTestimonialHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService
  ) {}

  getClientTestimonials(
    personaProviderId: number,
    apiOpts: Partial<IAPIListRequestOptions> = {}
  ): Observable<IAPIListResponse<IClientTestimonial>> {
    const url = `${this.configurationService.env.svcBase}/provider_profiles/${personaProviderId}/testimonials`;
    const params = this.http.generateListParams(apiOpts);

    return this.http
      .get<IAPIListResponse<IClientTestimonialResponse>>(url, params)
      .pipe(
        map((resp) => ({ ...resp, data: clientTestimonialResponseTransformer(resp.data) })),
        this.http.handleHttpError()
      );
  }
}
